const updates = [
  {
    id: 1,
    time: '10分钟前',
    title: '51吃瓜网址新增备用域名线路，访问更稳定',
    tag: '站点',
    tagColor: 'bg-primary-100 text-primary-700',
  },
  {
    id: 2,
    time: '1小时前',
    title: '今日娱乐圈头条：顶流明星恋情疑似曝光，引爆全网热议',
    tag: '爆料',
    tagColor: 'bg-accent-100 text-accent-800',
  },
  {
    id: 3,
    time: '2小时前',
    title: '热播古装剧大结局口碑炸裂，豆瓣评分创今年新高',
    tag: '剧集',
    tagColor: 'bg-secondary-100 text-secondary-800',
  },
  {
    id: 4,
    time: '3小时前',
    title: '某知名网红直播带货翻车，网友神评论合集出炉',
    tag: '网红',
    tagColor: 'bg-accent-100 text-accent-800',
  },
  {
    id: 5,
    time: '5小时前',
    title: '体育圈重磅转会传闻：巨星或将加盟新东家',
    tag: '体育',
    tagColor: 'bg-secondary-100 text-secondary-800',
  },
  {
    id: 6,
    time: '6小时前',
    title: '科技圈年度大瓜：两大互联网巨头正面交锋细节曝光',
    tag: '科技',
    tagColor: 'bg-primary-100 text-primary-700',
  },
  {
    id: 7,
    time: '8小时前',
    title: '新一季综艺节目阵容官宣，网友期待值爆表',
    tag: '综艺',
    tagColor: 'bg-accent-100 text-accent-800',
  },
  {
    id: 8,
    time: '10小时前',
    title: '海外娱乐圈动态：好莱坞年度盛典红毯亮点回顾',
    tag: '国际',
    tagColor: 'bg-secondary-100 text-secondary-800',
  },
  {
    id: 9,
    time: '12小时前',
    title: '51吃瓜官网全网最新入口更新通知：新增移动端优化线路',
    tag: '站点',
    tagColor: 'bg-primary-100 text-primary-700',
  },
];

export default function UpdatesSection() {
  return (
    <section id="updates" className="w-full py-10 md:py-14 bg-background-50">
      <div className="w-full px-4 md:px-6 max-w-[1200px] mx-auto">
        <div className="text-center mb-8 md:mb-10">
          <h2 className="font-heading text-xl md:text-3xl font-bold text-foreground-950 mb-3">最新快讯</h2>
          <p className="text-foreground-600 text-sm md:text-base">实时追踪最热话题，新鲜资讯不停歇</p>
        </div>

        <div className="max-w-3xl mx-auto">
          {updates.map((item, idx) => (
            <div
              key={item.id}
              className="relative pl-8 pb-6 last:pb-0 group cursor-pointer"
            >
              {idx !== updates.length - 1 && (
                <div className="absolute left-[11px] top-8 bottom-0 w-0.5 bg-background-200"></div>
              )}
              <div className="absolute left-0 top-1.5 w-[22px] h-[22px] rounded-full bg-background-50 border-2 border-primary-300 group-hover:border-primary-500 group-hover:bg-primary-50 transition-colors flex items-center justify-center">
                <div className="w-1.5 h-1.5 rounded-full bg-primary-500"></div>
              </div>

              <div className="flex flex-col sm:flex-row sm:items-center gap-2 sm:gap-3 mb-1">
                <span className="text-xs text-foreground-500 whitespace-nowrap">{item.time}</span>
                <span className={`px-2 py-0.5 rounded text-xs font-medium whitespace-nowrap ${item.tagColor}`}>
                  {item.tag}
                </span>
              </div>
              <h3 className="text-sm md:text-base font-medium text-foreground-900 group-hover:text-primary-600 transition-colors leading-relaxed">
                {item.title}
              </h3>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}